import React, { useEffect } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { ReactTyped } from 'react-typed';
import AOS from 'aos';
import 'aos/dist/aos.css';
import content from '../../../content';
import './HomeMobile.css';

const { hero } = content;

function HomeMobile() {
  useEffect(() => {
    AOS.init({ duration: 900, once: true, offset: 60 });
  }, []);

  return (
    <section className="hero-mobile" id="heroSection">
      <div className="hero-mobile-overlay" />
      <div className="hero-content-mobile" data-aos="fade-up">
        {hero.greeting && <p className="hero-mobile-greeting">{hero.greeting}</p>}
        <h1 className="hero-mobile-name">{content.meta.name}</h1>
        {hero.roles.length > 0 && (
          <div className="hero-mobile-typed">
            {hero.roles.length > 1 ? (
              <ReactTyped strings={hero.roles} typeSpeed={60} backSpeed={40} loop />
            ) : (
              hero.roles[0]
            )}
          </div>
        )}
        {hero.tagline && <p className="hero-mobile-tagline">{hero.tagline}</p>}
        <div className="hero-mobile-cta-group">
          {hero.primaryCta && (
            <ScrollLink
              to={hero.primaryCta.target}
              smooth={true}
              duration={500}
              className="cta-mobile-primary"
            >
              {hero.primaryCta.label}
            </ScrollLink>
          )}
          {hero.secondaryCta && (
            <ScrollLink
              to={hero.secondaryCta.target}
              smooth={true}
              duration={500}
              className="cta-mobile-secondary"
            >
              {hero.secondaryCta.label}
            </ScrollLink>
          )}
        </div>
      </div>
    </section>
  );
}

export default HomeMobile;
